import { notifications } from '@mantine/notifications'
import { trpc } from '../trpc'

export const customerHooks = {
  useList: () => trpc.customer.list.useQuery({}),
  useUpdateName: () => {
    const utils = trpc.useUtils()
    return trpc.customer.update.useMutation({
      onSuccess: () => {
        utils.customer.list.invalidate()
        notifications.show({
          title: 'Asiakkuus päivitetty',
          message: 'Asiakkuuden nimi päivitetty onnistuneesti',
          color: 'green',
        })
      },
      onError: (error) => {
        notifications.show({
          title: 'Virhe',
          message: error.message || 'Asiakkuuden päivitys epäonnistui',
          color: 'red',
        })
      },
    })
  },
}
